'use strict';


export default function() {
	return {
		link: postLink,
	}

	function postLink(scope, element, attrs) {
		element.addClass('action-box-option-body');
		element.append(scope.$eval(attrs.actionBoxOptionBody));
	}
}
